import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import Quill from 'quill';

if (typeof window !== 'undefined' && !window.Quill) {
  window.Quill = Quill;
}

export default Quill;